import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import TabView from "../../Components/TabView";
import { TabType } from "../../Types/Tab.type";
import Gears from "../../Components/Profile/Gears";
import { RiderProfileLayoutContextInterface } from "./RiderProfileLayout";
import { RiderProductModel } from "../../Api/Models/rider.model";
import { riderService } from "../../Api/Services/RiderService";
import { useLoading } from "../../Context/LoadingProvider";
import { KitModel } from "../../Api/Models/product.model";
import CheckHistory from "./CheckHistory";
import { useUser } from "../../Context/UserProvider";


interface RiderProfileProps {}

const RiderProfile: React.FunctionComponent<RiderProfileProps> = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { startLoading, finnishLoading } = useLoading();
  const [allLoadingDone, setAllLoadingDone] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    setPageTitle,
    rider,
    showTabsNavbar,
    setHasGear,
    setGearExchangeRequired,
    subTitle,
    setGearMissing,
  } = useOutletContext<RiderProfileLayoutContextInterface>();

  const [gears, setGears] = useState<RiderProductModel[]>([]);
  const [missingKitProducts, setMissingKitProducts] = useState<KitModel | null>(
    null
  );

  const fetchGears = () => {
    startLoading("get-profile-gear");
    riderService
      .listGear(rider.riderId)
      .then((gear) => {
        setGears(gear);

        if(gear.length === 0 || !gear){
          fetchGearsSecondTry();
        }
      })
      .finally(() => {
        finnishLoading("get-profile-gear");
      });

    fetchMissingKitProducts();
  };

  const fetchGearsSecondTry = () => {
    startLoading("get-profile-gear");
    riderService
        .listGear(rider.riderId)
        .then((gear) => {
          setGears(gear);
        })
        .finally(() => {
          finnishLoading("get-profile-gear");
        });
  };

  const fetchMissingKitProducts = () => {
    startLoading("get-missing-produts");
    riderService
      .getMissingKitProducts(rider.riderId)
      .then((kit) => {
        setMissingKitProducts(kit);
      })
      .finally(() => {
        finnishLoading("get-missing-produts");
        setAllLoadingDone(true);
      });
  };

  useEffect(() => {
    fetchGears();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setHasGear(gears.length > 0);
    setGearExchangeRequired(
      gears.filter((x) => !x.exchangeAvailableAt).length > 0
    );
    //eslint-disable-next-line
  }, [gears]);

  useEffect(() => {
    setPageTitle();
  }, [t, setPageTitle]);

  useEffect(() => {
    setGearMissing(missingKitProducts?.products?.length ?? null);
  }, [missingKitProducts, setGearMissing]);



    const tabs: TabType[] = [
        ...(!user?.disable_gear_section ? [{
            element: (
                <Gears
                    gears={gears}
                    rider={rider}
                    subTitle={subTitle}
                />
            ),
            key: "gear",
            title: t("Gear"),
        }] : []),

        {
            element: <CheckHistory subTitle={subTitle} />,
            key: "history",
            title: t("History"),
        },
    ];

    if (allLoadingDone){
    return (
            <>
                <div className="card mb-4" style={{paddingBottom: "0px" }}>
                    {t("Total violations")}: {rider.totalViolations}
                    <div className="text-light text-small">Violations in past 30 days</div>
                    <div className="separator-line" style={{ paddingTop: "5px", paddingBottom: "0px" }}></div>

                    <table className="dp-table">
                        <tbody>
                        {rider.fakeLicensePlateCount > 0 &&
                            <tr>
                                <td>{t("Fake license")}</td>
                                <td className="dp-table__marked">{rider.fakeLicensePlateCount}</td>
                            </tr>
                        }
                        {rider.expiredProductsCount > 0 &&
                            <tr>
                                <td>{t("Expired gear")}</td>
                                <td className="dp-table__marked">{rider.expiredProductsCount}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>

                <button
                    type="button"
                    onClick={() => navigate(`/rider/${rider.riderId}/start-check`)}
                    className="button mb-4 w-full"
                >
                    {t("Start check")}
                </button>

                
               

                  <TabView tabs={tabs} showTabsNavbar={showTabsNavbar} />
               
                  <div>
                      <div className="mt-4 w-80">
                          
                      </div>
                  </div>
              
             
            </>
    );
  }

  return null;

};

export default RiderProfile;
